<template>
<div class="chapter">
<div class="inner_page">
<h1 class="CHAP-TITLE">Magic Menagerie</h1>
<p class="BOD2">Use acid colours and simple shapes to create a cute and whimsical collection of feathered and furry friends. And wait for the snail!</p>
<p class="IMAGE"><img alt="" src="images/C1-19.jpg"/></p>
<p class="IMAGE"><img alt="" src="images/C1-20.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter1-10.vue?3c7a63f3